import { useQuery } from '@tanstack/react-query';

const generateRandomSubtitle = () => {
  const words = [
    'The',
    'quick',
    'brown',
    'fox',
    'jumps',
    'over',
    'the',
    'lazy',
    'dog',
    'and',
    'runs',
    'into',
    'the',
    'forest',
  ];
  const subtitleLength = Math.floor(Math.random() * (13 - 8 + 1)) + 8; // Random length between 8 and 13
  let subtitle = '';
  for (let i = 0; i < subtitleLength; i++) {
    subtitle += words[Math.floor(Math.random() * words.length)] + ' ';
  }
  return subtitle.trim();
};

const fetchArticles = async () => {
  const response = await fetch(
    'https://gatehousemaritime.com/wp-json/wp/v2/marinepulse?acf_format=standard&per_page=100'
  );
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return await response.json();
};

export const useArticles = () => {
  const onPremise = import.meta.env.VITE_ON_PREMISE === 'true';

  const fetchArticlesConditionally = async () => {
    if (!onPremise) {
      return fetchArticles();
    } else {
      const response = await fetch('offline_help.json');
      if (!response.ok) {
        throw new Error('Failed to fetch articles from local JSON');
      }
      return response.json();
    }
  };

  return useQuery({
    queryKey: ['articles'],
    queryFn: fetchArticlesConditionally,
  });
};
